import { Box, useTheme } from '@mui/material'
import { Header, Footer } from 'navigation/components'
import { PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'
import HealthStatusListenerProvider from 'services/context/healthStatusListener'
import HealthStatusBanner from 'components/HealthStatusBanner'

const BaseScreenContent: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation()
  const theme = useTheme()

  return (
    <Box>
      <HealthStatusBanner />
      <Header />
      <Box
        display='flex'
        flexDirection='column'
        sx={[
          location.pathname.includes('/chats')
            ? {
                maxHeight: 'calc(100vh - 136px)'
              }
            : {
                minHeight: 'calc(100vh - 154px)',
                marginBottom: '32px'
              },
          {
            ml: '65px',
            [theme.breakpoints.down('sm')]: {
              ml: '56px'
            }
          }
        ]}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  )
}

const BaseScreen: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <HealthStatusListenerProvider>
      <BaseScreenContent>{children}</BaseScreenContent>
    </HealthStatusListenerProvider>
  )
}

export default BaseScreen
